import React from 'react';

export default function PrivacyPolicy() {
  return (
    <div className="legal-universe-wrapper white-gallery-canvas">
      <section className="legal-hero-banner text-center">
        <div className="container dynamic-fade-rise">
          <span className="legal-eyebrow">🛡️ DATA PRIVACY ENGINES</span>
          <h1>Privacy Policy<br /><span className="dark-gold-txt">Corporate Data Protection Commitments</span></h1>
          <div className="legal-title-line"></div>
          <p>Understand how our infrastructure processes trade credentials, design briefs, and technical schematics securely.</p>
        </div>
      </section>

      <section className="container architectural-narrow-column strict-prose-layout">
        <p className="effective-date-tag"><strong>Last Updated & Revised:</strong> June 2026</p>

        <h3>1. Information We Securely Procure</h3>
        <p>To process bulk wholesale quotes, custom design briefs, and distribute master catalogs, we harvest basic corporate identifiers. This includes company name, professional email points, direct contact lines, physical delivery destinations, and structural drawings or blueprint attachment packages uploaded via our custom customization terminal.</p>

        <h3>2. How Your Project Data is Deployed</h3>
        <p>We do not participate in retail tracking models or share data with external consumer advertising lists. Collected information is deployed exclusively to generate technical specification sheets, evaluate manufacturing tolerances for custom inquiries, process freight logistics, and forward product updates to registered design firms.</p>

        <h3>3. Schematic & Blueprint Confidentiality</h3>
        <p>We treat every uploaded technical image, floor layout plan, and design file as strictly proprietary. Project blueprints are isolated on our secure internal network and accessible only to assigned production engineers and foundry craftsmen. They are never shared outside our company network without express corporate written consent.</p>

        <h3>4. Security Protocols</h3>
        <p>We deploy industrial-grade data protection parameters along with verified socket level encryptions to protect your records from unexpected access or breach hazards.</p>

        <h3>5. Rights Matrix</h3>
        <p>Professional design partners and enterprise associates reserve the complete right to request detailed access logs of their processed credentials or command complete system data deletion at any stage by drafting a direct request to our desk at: <strong>b2b@lightingale.in</strong>.</p>
      </section>
    </div>
  );
}